/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Invoke_Api_Batch_RequestsInputs */



/**
* | output |
* | --- |
* | "Batch · {count} requests" |
*
* @param {Chat_Invoke_Api_Batch_RequestsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_invoke_api_batch_requests = /** @type {((inputs: Chat_Invoke_Api_Batch_RequestsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Invoke_Api_Batch_RequestsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Stapel · ${i?.count} Anfragen`)
	return /** @type {LocalizedString} */ (`Batch · ${i?.count} requests`)
});